import { AddOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";
import {
    ListDetailItemList,
    ListDetailViewSectionContent,
    ListDetailViewSectionHeader,
    ListDetailViewSectionLayout,
    ListViewItem,
} from "../../components/ListDetailView";
import { useUserInfo } from "../../utils/security";

const EmployeeListItem = ({ data, _onClick, ...props }) => {
    const { userInfo } = useUserInfo();
    return <ListViewItem {...props} mainText={data.displayName} />;
};

export const EmployeesList = ({
    overviewState,
    compact,
    loading,
    onAddEmployee,
    data,
    selectItem,
    detailId,
    setFilter,
    filter,
    filterVisible,
    setFilterVisible,
    onShowRecurringDialog,
}) => {
    const { userInfo } = useUserInfo();
    console.log(detailId);

    return (
        <ListDetailViewSectionLayout loading={loading}>
            <ListDetailViewSectionHeader
                title="Lidé"
                role="list"
                loading={loading}
                compact={compact}
                actions={[
                    {
                        title: "Přidat ...",
                        icon: <AddOutlined />,
                        items: (userInfo?.employeeTypes || []).map((employeeType) => ({
                            title: employeeType.name,
                            icon: <AddOutlined />,
                            onClick: () => onAddEmployee?.(employeeType),
                        })),
                    },
                ]}>
                {/*<EmployeeSimpleFilter />*/}
            </ListDetailViewSectionHeader>
            <ListDetailViewSectionContent>
                <Box px={2}>
                    {/*
                    <EmployeeAdvancedFilter />
                    {compact === true && (
                        <EmployeesOverviewContent
                            data={overviewState?.data}
                            loading={overviewState?.loading}
                        />
                    )}
                        */}
                </Box>
                <ListDetailItemList
                    data={data}
                    loading={loading}
                    renderItem={EmployeeListItem}
                    compact={compact}
                    detailId={detailId}
                    selectItem={selectItem}
                />
            </ListDetailViewSectionContent>
        </ListDetailViewSectionLayout>
    );
};
